export default __webpack_public_path__ + "static/media/atul.e8cc7999.jpeg";